import cx from "classnames";
import { CSSProperties } from "react";
import { FundingRequestStatus } from "shared/api";
import styles from "./status.module.scss";

export interface IStatus {
  status?: FundingRequestStatus;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
  type?: "default" | "text";
  row?: "row" | "reverse";
}

export const Status = (props: IStatus) => {
  const statuses = {
    [FundingRequestStatus.DRAFT]: {
      label: "Черновик",
      color: styles.yellow_outline,
    },
    [FundingRequestStatus.NEW]: {
      label: "Ждет допуска к ФП",
      color: styles.yellow_outline,
    },
    [FundingRequestStatus.ADMITTED]: {
      label: "Допущена к ФП",
      color: styles.yellow,
    },
    [FundingRequestStatus.APPROVED]: {
      label: "К выплате",
      color: styles.green,
    },
    [FundingRequestStatus.CLOSED]: {
      label: "Закрыта",
      color: styles.gray,
    },
    [FundingRequestStatus.DECLINED]: {
      label: "Отклонена",
      color: styles.gray,
    },
    [FundingRequestStatus.CANCELED]: {
      label: "Отменена",
      color: styles.gray,
    },
  };

  return (
    <>
      {props.status && (
        <div
          className={cx(
            styles.status,
            props.className,
            props.row && styles[props.row],
            props.type && styles[props.type]
          )}
          style={props.style}
          id={props.htmlId}
        >
          <span className={cx(styles.circle, statuses?.[props.status].color)} />
          <span className={styles.label}>{statuses?.[props.status].label}</span>
        </div>
      )}
    </>
  );
};

Status.defaultProps = {
  type: "default",
  row: "row",
};
